import React from 'react';
export class ObserveConfigComponent extends React.Component {
  static defaultProps = {
    id: 'mlb-one-header-config',
    render: () => null
  };

  state = {
    config: JSON.parse(window.document.getElementById(this.props.id).innerHTML)
  };

  observer = null;

  componentDidMount() {
    try {
      this.observer = new MutationObserver(() => {
        this.setConfig();
      });

      this.observer.observe(window.document.getElementById(this.props.id), {subtree: true, childList: true, characterData: true});
    } catch (err) {
      console.error(err);
    }

    this.setConfig();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setConfig = () => {
    const headerJson = window.document.getElementById(this.props.id).innerHTML;
    const config = JSON.parse(headerJson);

    this.setState({
      config
    });
  }

  render() {
    if (!this.state.config) {
      return null;
    }

    return this.props.render({
      config: this.state.config
    });
  }
}



// WEBPACK FOOTER //
// ./src/observe-config.js